import * as React from 'react';

import {MeetingFormPublishModal} from './meeting-form-publish-modal';
import {NutshellFormPublishModal} from './nutshell-form-publish-modal';

type Props = {
    isMeetingForm?: boolean;
    formId: string;
    onClose: () => void;
    onPublish: () => void;
};

export function PublishModal(props: Props) {
    const {isMeetingForm, ...restProps} = props;

    return (
        <>
            {isMeetingForm ? (
                <MeetingFormPublishModal {...restProps} />
            ) : (
                <NutshellFormPublishModal {...restProps} />
            )}
        </>
    );
}
